import React from 'react';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { classnames } from 'helpers/utils';
import * as styles from './subscription-banner.module.scss';
import { SmartLink } from 'components/smart-link';

type SubsBannerType = {
  title: string;
  description?: string;
  image?: IGatsbyImageData
  className?: string
  link:string
  nameLink:string 
};

export const SubscriptionBanner = ({
  title, description, image, className,nameLink,link
}: SubsBannerType) => {
  return (
    <div className={classnames(styles.headBanner, className || '')}>
      <div className={styles.genericContainer}>
        <div className={styles.headContent}>
          {image
            && (
              <GatsbyImage
                image={image}
                alt={title}
                className={styles.headingImage}
              />
            )}
          <div className={styles.headingText}>
            <h2 className={styles.headingTitle}>{title}</h2>
            {description && <p className={styles.headingDescription}>{description}</p>}
            <SmartLink
              key={nameLink}
              ariaLabel={nameLink}
              to={link}
              className={styles.buttonStyle}
            >
              {nameLink}
            </SmartLink>
          </div>
        </div>
      </div>
    </div>
  );
};
